import OperationButton from "@/components/FollowButton/operationButton";
import useAppStore from "@/context/store";
import useRequest from "@/utils/useReq";
import { Button } from "antd";
import classNames from "classnames";
import { useCallback, useMemo, useState } from "react";
import { Else, If, Then, When } from "react-if";
import { SEX_MAP } from "../../constants/sex";
import { followUser, unfollowUser } from "../../services";
import displayNum from "../../utils/displayNum";
import getTimeDuration from "../../utils/getTimeDuration";
import imageUrl from "../../utils/imageUrl";
import HBIcon from "../HBIcon";
import Image from "../Image";
import { useJobName } from "../JobSelect/useCrowdTag";
import { useLogin } from "../LoginModal";
import { MuseTag } from "../Muse";
import UserAvatar from "../UserAvatar";
import styles from "./index.module.less";

export default function UserLineCard({ className, record, onFollow }) {
  const { config, user } = useAppStore(({ config, user }) => ({
    config,
    user,
  }));
  const { login } = useLogin();

  const [following, setFollowing] = useState(record.following);
  const { runAsync: runFollow } = useRequest(followUser, {
    manual: true,
  });
  const { runAsync: runUnfollow } = useRequest(unfollowUser, {
    manual: true,
  });

  const onToggleFollow = useCallback(async () => {
    if (!user) {
      const result = await login();
      if (!result) {
        return;
      }
    }

    if (following) {
      const result = await runUnfollow(record.urlname);
      if (!result.err) {
        record.following = false;
        setFollowing(false);
        onFollow && onFollow(false);
      }
    } else {
      const result = await runFollow(record.urlname);
      if (!result.err) {
        record.following = true;
        setFollowing(true);
        onFollow && onFollow(true);
      }
    }
  }, [following, login, record, runFollow, runUnfollow, onFollow, user]);

  const time = useMemo(() => {
    const createTime = record.pins?.[0]?.created_at;
    return createTime ? getTimeDuration({ time: createTime * 1000 }) : "";
  }, [record]);

  const isOfficial = useMemo(() => {
    return config?.officialUsers?.split(",").includes(record?.urlname);
  }, [record, config]);

  const jobName = useJobName(record);

  return (
    <div className={classNames([styles.lineCard, className])}>
      <a
        href={`/user/${record.urlname}`}
        target="_blank"
        className={styles.avatar}
      >
        <UserAvatar user={record} size="large" />
      </a>
      <div className={styles.info}>
        <div className={styles.title}>
          <a
            href={`/user/${record.urlname}`}
            target="_blank"
            className={styles.text}
          >
            {record.username}
          </a>
          <When condition={isOfficial}>
            <span className={styles.official} title="花瓣官方"></span>
          </When>
          <When condition={record.extra?.is_museuser}>
            <MuseTag size={24} user={record} />
          </When>
        </div>
        <div className={styles.num}>
          {displayNum(record.pin_count)}采集 ·{" "}
          {displayNum(record.follower_count)}粉丝
        </div>
        <div className={styles.more}>
          <When condition={jobName}>
            <div className={styles.item}>{jobName}</div>
          </When>
          <div className={styles.item}>
            {SEX_MAP[record.profile?.data?.sex] || "保密"}
          </div>
          <When condition={record.profile?.data?.location}>
            <div className={classNames([styles.item, styles.flex])}>
              <div
                className={styles.onelineShort}
                title={record.profile?.data?.location}
              >
                {record.profile?.data?.location}
              </div>
            </div>
          </When>
          <When condition={record.profile?.data?.about}>
            <div className={classNames([styles.item, styles.flex])}>
              <div
                className={styles.oneline}
                title={record.profile?.data?.about}
              >
                {record.profile?.data?.about}
              </div>
            </div>
          </When>
        </div>
        <If condition={time}>
          <Then>
            <div className={styles.action}>{time} 新增了采集</div>
          </Then>
          <Else>
            <div className={styles.action}></div>
          </Else>
        </If>
        <div className={styles.button}>
          <When condition={user?.user_id !== record.user_id}>
            <If condition={following}>
              <Then>
                {/* <Button
                  size="small"
                  onClick={onToggleFollow}
                  data-gd-click="button_click"
                  data-button-name="取消关注"
                  data-concern-object-type="用户"
                  data-concern-object-name={record?.username}
                >
                  已关注
                </Button> */}
                <OperationButton
                  className={styles.operationButton}
                  onClick={onToggleFollow}
                  data-gd-click="button_click"
                  data-button-name="取消关注"
                  data-concern-object-type="用户"
                  data-concern-object-name={record?.username}
                  userInfo={record}
                ></OperationButton>
              </Then>
              <Else>
                <Button
                  type="primary"
                  size="small"
                  icon={<HBIcon type="ic_star" />}
                  onClick={onToggleFollow}
                  data-gd-click="button_click"
                  data-button-name="关注"
                  data-concern-object-type="用户"
                  data-concern-object-name={record?.username}
                >
                  关注Ta
                </Button>
              </Else>
            </If>
          </When>
        </div>
      </div>
      <div className={styles.gallery}>
        {Array(5)
          .fill(0)
          .map((_, index) => {
            const pin = record.pins?.[index];

            return (
              <div className={styles.item} key={index}>
                {pin && (
                  <a href={`/pins/${pin.pin_id}`} target="_blank">
                    <Image src={imageUrl(pin.file, { width: 240 })} alt="" />
                  </a>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}
